<template>
  <div class="bg-secondary">
    <div class="container py-3">
      <div class="row pt-1 align-items-center">
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 pbelow" style="color: white;">
          <span>© 2024 Copyright: Julio Notodiprodyo</span>
        </div>

        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12">
          <div class="text-center">
            <button class="btn btn-outline-secondary mx-2 " @click="open('linkedin')">
              <i class="fab fa-linkedin"></i>
            </button>
            <button class="btn btn-outline-secondary mx-2" @click="open('github')">
              <i class="fab fa-github"></i>
            </button>
            <button class="btn btn-outline-secondary mx-2" @click="open('resume')">
              <i class="fa fa-file"></i>
            </button>
            <button
              class="btn btn-outline-secondary mx-2"
              :class="{ 'music-active': musicPlaying }"
              @click="$emit('musicToggle')"
              v-tooltip.bottom="musicPlaying ? 'Mute Music' : 'Play Music'"
            >
              <i :class="musicPlaying ? 'fas fa-volume-up' : 'fas fa-volume-mute'"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

export default {
  name: "Footer",
  props: {
    musicPlaying: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      linkedin: info.links.linkedin,
      github: info.links.github,
      resume: info.links.resume,
    };
  },
  methods: {
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "github":
          window.open(this.github, "_blank");
          break;
        case "resume":
          window.open(this.resume, "_blank");
          break;
      }
    },
  },
};
</script>

<style scoped>
span {
  font-weight: 500;
}

.btn {
  border-color: white;
  color: white;
}

.btn:hover {
  background-color: white;
  border-color: white;
  color: gray;
}

.btn:focus {
  background-color: white;
  border-color: white;
  color: gray;
}

.music-active {
  background-color: white;
  border-color: white;
  color: #759CC9 !important;
}

@media screen and (max-width: 580px) {
  .pbelow {
    padding-bottom: 20px;
    text-align: center;
  }
}
</style>
